module.exports = __webpack_public_path__ + "static/media/shapes_07.c3f2b398.svg";